<button
  class="download-button"
  [disabled]="!finishedDownload"
  (click)="downloadCSV()"
  title="Download CSV"
>  
  <i 
  class="downloadIcon"
  [ngClass]="{'loading': !finishedDownload}"
  >
  </i>
</button>
